// src/app/modules/Auth/pages/ForgotPassword.jsx
import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { injectIntl } from "react-intl";
import { forgotPassword } from "../_redux/authCrud";
import './auth.scss';
import { Mail, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const initialValues = {
  email: "",
};

function ForgotPassword(props) {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
    

  const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: ForgotPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      setStatus('');

      forgotPassword({ email: values.email })
        .then((response) => {
          setLoading(false);
          setSubmitting(false);
        
        //   if (data.status === 'Success') {
        setSuccess(true);
        // Redirect to reset password page
        setTimeout(() => {
            navigate('/auth/reset-password',
               { state: { email: values.email }}
            );
        }, 1000);
        //   } else {
        //     setStatus(data.message || 'Failed to send reset code');
        //   }
        })
        .catch((error) => {
          setLoading(false);
          setSubmitting(false);
          const message = error.response?.data?.message || 'An error occurred';
          setStatus(message);
        });
    },
  });

  return (
    <div className="clean-login-card">
      <div className="login-header">
        <div className="verification-icon">
          <Mail size={32} />
        </div>
        <h1 className="login-title">Forgot Password?</h1>
        <p className="login-subtitle">
          No worries! Enter your email and we'll send you a reset code.
        </p>
      </div>

      {formik.status && (
        <div className="login-alert">
          {formik.status}
        </div>
      )}

      {success && (
        <div className="login-alert success">
          Reset code sent! Check your email. Redirecting...
        </div>
      )}

      <form onSubmit={formik.handleSubmit} className="login-form">
        {/* Email */}
        <div className="form-group">
          <label className="form-label">Email</label>
          <input
            type="email"
            name="email"
            placeholder="Enter your email"
            className={`form-control ${
              formik.touched.email && formik.errors.email ? 'error' : ''
            }`}
            {...formik.getFieldProps("email")}
            disabled={success}
          />
          {formik.touched.email && formik.errors.email && (
            <div className="form-error">{formik.errors.email}</div>
          )}
        </div>

        {/* Submit */}
        <button
          type="submit"
          disabled={formik.isSubmitting || loading || success}
          className="submit-btn"
        >
          {loading ? (
            <>
              Sending code...
              <span className="spinner"></span>
            </>
          ) : (
            'Send Reset Code'
          )}
        </button>

        {/* Back to Login */}
        <button
          type="button"
          className="back-btn"
          onClick={() => navigate('/auth/login')}
        >
          <ArrowLeft size={16} />
          Back to Sign In
        </button>
      </form>
    </div>
  );
}

export default injectIntl(ForgotPassword);